// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__6vd08"};